<template>
    <div class="product" >
        <!-- <div :style="pos?'min-height:12.2rem':'min-height:8.3rem;'"></div> -->
        <div style="min-height:8.3rem"></div>
        <section class="banner" data-aos="fade-up" data-aos-duration="1000">
            <img  class="hidden-xs-only" src="/imgs/product/canping_banner.jpg" alt="" />
            <img  class="hidden-sm-and-up" src="/imgs/product/banner_d.png" alt="" />
            <div data-aos="slide-left" data-aos-duration="1000">
                <h1>产品及方案</h1>
                <p>智慧采血解决方案，让采血更安全</p>
            </div>
        </section>
        
        
        <!-- <section class="pro1" >
            <div class="space" id="1"></div>
            <div class="pro-title" >
                <div class="title">
                    <h3>血站产品</h3>
                    <span></span>
                </div>
            </div>
            <div class="pro-swiper-container first-swiper">
                <div class="swiper-wrapper">
                    <div
                        v-for="item,idx of pro1"
                        :key="'pro1'+idx"
                        class="swiper-slide"
                    >
                        <div class="pro-content-item">
                            <div class="pro-content-item-cover">
                                <img  :src="item.coverImg" alt="" />
                                <div class="triangle"></div>
                            </div>
                            <div class="pro-content-item-desc">
                                <h2>{{item.name}}</h2>
                                <h3>{{ item.desc }}</h3>
                                <p>{{ item.descs }}</p>
                                <div @click="handleDetail(item)">
                                    <span>了解详情</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="swiper-pagination"></div>

                <div class="swiper-button-prev hidden-xs-only">
                    <i class="el-icon-arrow-left"></i>
                </div>
                <div class="swiper-button-next hidden-xs-only">
                    <i class="el-icon-arrow-right"></i>
                </div>

                <div class="swiper-button-prev prev-xs hidden-sm-and-up">
                    <i class="el-icon-arrow-left"></i>
                </div>
                <div class="swiper-button-next next-xs hidden-sm-and-up">
                    <i class="el-icon-arrow-right"></i>
                </div>
            </div>
        </section>

        <section class="pro1" >
            <div class="space" id="2"></div>
            <div class="pro-title" >
                <div class="title">
                    <h3>临床产品</h3>
                    <span></span>
                </div>
            </div>
            <div class="pro-swiper-container second-swiper">
                <div class="swiper-wrapper">
                    <div
                        v-for="item,idx of pro3"
                        :key="'pro3'+idx"
                        class="swiper-slide"
                    >
                        <div class="pro-content-item">
                            <div class="pro-content-item-cover">
                                <img  :src="item.coverImg" alt="" />
                                <div class="triangle"></div>
                            </div>
                            <div class="pro-content-item-desc">
                                <h2>{{item.name}}</h2>
                                <h3>{{ item.desc }}</h3>
                                <div @click="handleDetail(item)">
                                    <span>了解详情</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="swiper-pagination"></div>

                <div class="swiper-button-prev hidden-xs-only">
                    <i class="el-icon-arrow-left"></i>
                </div>
                <div class="swiper-button-next hidden-xs-only">
                    <i class="el-icon-arrow-right"></i>
                </div>

                <div class="swiper-button-prev prev-xs hidden-sm-and-up">
                    <i class="el-icon-arrow-left"></i>
                </div>
                <div class="swiper-button-next next-xs hidden-sm-and-up">
                    <i class="el-icon-arrow-right"></i>
                </div>
            </div>
        </section> -->

        <div v-if="productType==='cplx1'">
            <section v-for="(item,idx) of pro1" :key="'pro1'+idx" class="pro2" >
            <div class="space" :id="item.id"></div>
            <div class="pro-title">
                <div class="title">
                    <h3 class="h3-title">{{item.title}}</h3>
                    <!-- <span></span> -->
                </div>
            </div>
            <div class="pro-content-item" >
                <div class="pro-content-item-cover">
                    <img  :src="item.coverImg" alt="" />
                </div>
                <div class="pro-content-item-desc">
                    <h2>{{item.name}}</h2>
                    <h3>{{ item.desc }}</h3>
                    <p>{{ item.descs }}</p>
                    <div @click="handleDetail(item)">
                        <span>了解详情</span>
                    </div>
                    </div>
                </div>
            </section>
        </div>

        <div v-if="productType==='cplx2'">
            <section v-for="(item,idx) of pro3" :key="'pro3'+idx" class="pro2" >
            <div class="space" :id="item.id"></div>
            <div class="pro-title">
                <div class="title">
                    <h3 class="h3-title">{{item.title}}</h3>
                    <!-- <span></span> -->
                </div>
            </div>
            <div class="pro-content-item" >
                <div class="pro-content-item-cover">
                    <img  :src="item.coverImg" alt="" />
                </div>
                <div class="pro-content-item-desc">
                    <h2>{{item.name}}</h2>
                    <h3>{{ item.desc }}</h3>
                    <p>{{ item.descs }}</p>
                    <div @click="handleDetail(item)">
                        <span>了解详情</span>
                    </div>
                    </div>
                </div>
            </section>
        </div>
        

        <section class="nav-xs hidden-sm-and-up" >

            <div v-if="productType==='cplx1'">
                <div v-for="item,idx of nav" :key="'nav'+idx" @click="handleNav(item)">
                    <div :style="pos?'height:3.88rem;':'height:0;'" class="img">
                        <img  :src="item.img" alt="">
                    </div>
                    <p style="white-space: pre-wrap;" >{{item.name}}</p>
                </div>
            </div>

            <div v-if="this.productType==='cplx2'">
                <div v-for="item,idx of nav2" :key="'nav'+idx" @click="handleNav(item)">
                    <div :style="pos?'height:3.88rem;':'height:0;'" class="img">
                        <img  :src="item.img" alt="">
                    </div>
                    <p style="white-space: pre-wrap;" >{{item.name}}</p>
                </div>
            </div>
            
        </section>

        
        <!--  pc  -->
        <section class="nav-pc hidden-xs-only">

            <div id="selector-product-type">
                <div v-for="type in types" :key="type.id" :class="{ active: productType === type.id }" @click="selectType(type.id)" id="product-type">
                    {{ type.name }}
                </div>
            </div>
            <span class="product-type-bottom" />

            <div v-if="productType==='cplx1'" class="product-gallery">
                <span @click="navCurrentIndex > 0 && navCurrentIndex--" :class="navLeftButtonClass" class="arrow-btn" ><i class="el-icon-arrow-left"></i></span>
                <div v-for="item,idx of navDisplayedProducts" :key="'nav'+idx" @click="handleNav(item)" >
                    <div :style="pos?'height:3.88rem;':'height:0;'" class="img">
                        <img  :src="item.img" alt="" >
                    </div>
                    <p style="white-space: pre-wrap;" >{{item.name}}</p>
                </div>
                <span @click="navCurrentIndex < navTotalSteps && navCurrentIndex++" :class="navRightButtonClass" class="arrow-btn" ><i class="el-icon-arrow-right"></i></span>
            </div>

            <div v-if="this.productType==='cplx2'" class="product-gallery">
                <span @click="nav2CurrentIndex > 0 && nav2CurrentIndex--" :class="nav2LeftButtonClass" class="arrow-btn" ><i class="el-icon-arrow-left"></i></span>
                <div v-for="(item,idx) of nav2DisplayedProducts" :key="'nav'+idx" @click="handleNav(item)">
                    <div :style="pos?'height:3.88rem;':'height:0;'" class="img">
                        <img :src="item.img" alt="">
                    </div>
                    <p style="white-space: pre-wrap;" >{{ item.name }}</p>
                </div>
                <span @click="nav2CurrentIndex < nav2TotalSteps && nav2CurrentIndex++" :class="nav2RightButtonClass" class="arrow-btn" ><i class="el-icon-arrow-right"></i></span>
            </div>
        </section>
        
    </div>
</template>
<script>
import Swiper from "swiper";
import {EventBus} from "@/utils/EventBus";

export default {
    name: "Product",
    components: {},
    data() {
        return {
            types: [
                {id: 'cplx1', name: '血站产品' },
                
                {id: 'cplx2', name: '临床产品' },
            ],
            productType: 'cplx1',
            pos:true,
            navCurrentIndex: 0,//当前页数
            navProductsToShow: 5,//展示数量
            nav2CurrentIndex: 0,//当前页数
            nav2ProductsToShow: 5,//展示数量
            nav:[
                {'id':'cxxt01','name':'智能采血系统','img':'/imgs/product/nav/cxxt01.png','typeId':'cplx1',},
                {'id':'cxxt02','name':'智能采血系统','img':'/imgs/product/nav/canping_a.jpg','typeId':'cplx1',},
                {'id':'bxcxxt03s','name':'便携采血系统','img':'/imgs/product/nav/bxcxxt03S.png','typeId':'cplx1',},
                // {'id':'bxcxxt03z','name':'便携采血系统','img':'/imgs/product/nav/bxcxxt03Z.png','typeId':'cplx1',},
                // {'id':'xxzzfwxt','name':'智能献血自助服务系统','img':'/imgs/product/nav/xxzzfwxt.png','typeId':'cplx1',},
                // {'id':'jkzx','name':'智能健康征询系统','img':'/imgs/product/nav/canping_b.jpg','typeId':'cplx1',},
                {'id':'cxyzhb','name':'智能采血椅','img':'/imgs/product/nav/cxyzhb.png','typeId':'cplx1',},
                // {'id':'cxybzb','name':'智能采血椅','img':'/imgs/product/nav/cxybzb.png','typeId':'cplx1',},
                {'id':'czpt','name':'智能移动操作平台','img':'/imgs/product/nav/canping_c.jpg','typeId':'cplx1',},
                {'id':'xybb','name':'血液标本后处理系统','img':'/imgs/product/nav/canping_d.jpg','typeId':'cplx1',},
                {'id':'lljk','name':'智能冷链监控系统','img':'/imgs/product/nav/canping_e.jpg','typeId':'cplx1',},
                {'id':'cxc','name':'智能采血秤','img':'/imgs/product/nav/cxc.png','typeId':'cplx1',},
                {'id':'rhj','name':'智能热合机','img':'/imgs/product/nav/rhj.png','typeId':'cplx1',},
                {'id':'xxw','name':'智慧献血屋方案','img':'/imgs/product/nav/canping_h.jpg','typeId':'cplx1',},
            ],
            nav2: [
                {'id':'thirdCxxt800', 'name': '智能采血系统','img':'/imgs/product/nav/thirdCxxt800.png','typeId':'cplx2',},
                {'id':'thirdCxxt240', 'name': '智能采血系统', 'img': '/imgs/product/nav/thirdCxxt240.png','typeId':'cplx2',},
                {'id':'thirdCxxt240M', 'name': '智能采血系统', 'img': '/imgs/product/nav/thirdCxxt240M.png','typeId':'cplx2',},
                {'id':'thirdCxxt300', 'name': '智能采血系统', 'img': '/imgs/product/nav/thirdCxxt300.png','typeId':'cplx2',},
                {'id':'thirdZtxcjxt', 'name': '自体血采集系统', 'img': '/imgs/product/nav/thirdZtxcjxt.png','typeId':'cplx2',},
                {'id':'thirdBbzyjqr', 'name': '智能标本转运机器人', 'img': '/imgs/product/nav/thirdBbzyjqr.png','typeId':'cplx2',},
                {'id':'thirdNggl', 'name': '智能尿管管理系统', 'img': '/imgs/product/nav/thirdNggl.png','typeId':'cplx2',},
                {'id':'thirdBbfj', 'name': '智能标本分拣系统', 'img': '/imgs/product/nav/thirdBbfj.png','typeId':'cplx2',},
                // {'id':'thirdDgncxzjhszz', 'name': '多功能采血桌及回收装置', 'img': '/imgs/product/nav/thirdDgncxzjhszz.png','typeId':'cplx2',},
            ],
            
            pro1:[
                {
                    "id":'cxxt01',
                    'title':'智能采血系统',
                    'name':'智能采血系统01系列',
                    // 'desc':"全过程自动化环节质量控制\n保证血液质量安全",
                    // 'descs':"适用于标准血袋",
                    'coverImg':'/imgs/product/cxxt/canpingdatu_b.png'
                },
                {
                    "id":'cxxt02', 
                    'title':'智能采血系统',
                    'name':'智能采血系统02系列',
                    // 'desc':"全过程自动化环节质量控制\n保证血液质量安全",
                    // 'descs':"适用于旁路血袋",
                    'coverImg':'/imgs/product/cxxt/canpingdatu_a.png'
                },
                // {
                //     'id':'xxzzfwxt',
                //     'title':'智能献血自助服务系统',
                //     'name':'智能献血自助服务系统',
                //     // 'desc':"一站式体检，舒适便捷",
                //     'coverImg':'/imgs/product/jkzx/product_list_xxzzfwxt.png'
                // },
                // {
                //     'id':'jkzx',
                //     'title':'智能健康征询系统',
                //     'name':'智能健康征询系统',
                //     'desc':"一站检测、简易方便",
                //     'coverImg':'/imgs/product/jkzx/canpingdatu_c.png'
                // },
                {
                    'id':'czpt',
                    'title':'智能移动操作平台',
                    'name':'智能移动操作平台',
                    // 'desc':"优化成分血采集管理\n提升成分血采血服务",
                    'coverImg':'/imgs/product/czpt/canpingdatu_d.png'
                },
                {
                    'id':'bxcxxt03s',
                    'title':'便携采血系统',
                    'name':'便携采血系统',
                    // 'desc':"轻便快捷，野外采血无忧",
                    'coverImg':'/imgs/product/bxcxxt/03S_product_list_bxcxxt.png'
                },
                // {
                //     'id':'bxcxxt03z',
                //     'title':'便携采血系统',
                //     'name':'便携采血系统AT-IBCS03Z',
                //     'desc':"轻便快捷，外出采血无忧",
                //     'coverImg':'/imgs/product/bxcxxt/03Z_product_list_bxcxxt.png'
                // },
                {
                    'id':'cxyzhb',
                    'title':'智能采血椅',
                    'name':'智能采血椅',
                    // 'desc':"智慧献血，舒适体验",
                    'coverImg':'/imgs/product/cxy/product_list_cxyzhb.png'
                },
                // {
                //     'id':'cxybzb',
                //     'title':'智能采血椅',
                //     'name':'智能采血椅（标准版）',
                //     'desc':"轻便快捷，外出采血无忧",
                //     'coverImg':'/imgs/product/cxy/product_list_cxybzb.png'
                // },
                {
                    'id':'xybb',
                    'title':'血液标本后处理系统',
                    'name':'血液标本后处理系统',
                    // 'desc':"标本储存全流程溯源\n保障血液质量与安全",
                    'coverImg':'/imgs/product/xybb/canpingdatu_e.png'
                },
                {
                    'id':'lljk',
                    'title':'智能冷链监控系统',
                    'name':'智能冷链监控系统',
                    // 'desc':"为血液与标本\n安全运输保驾护航",
                    'coverImg':'/imgs/product/lljk/canpingdatu_f.png'
                },
                {
                    'id':'cxc',
                    'title':'智能采血秤',
                    'name':'智能采血秤',
                    // 'desc':"智能采血基础设备\n保障血液顺利采集",
                    'coverImg':'/imgs/product/cxc/product_list_cxc.png'
                },
                {
                    'id':'rhj',
                    'title':'智能热合机',
                    'name':'智能热合机',
                    // 'desc':"采血热合快速\n便携稳定可靠",
                    'coverImg':'/imgs/product/rhj/product_list_rhj.png'
                },
                {
                    'id':'xxw',
                    'title':'智慧献血屋方案',
                    'name':'智慧献血屋方案',
                    // 'desc':"无纸化智慧献血屋\n高效、安全",
                    'coverImg':'/imgs/product/xxw/canpingdatu_i.png'
                },
            ],

            pro3:[
                {
                    'id':'thirdCxxt800',
                    'title':'智能采血系统',
                    'name':'智能采血系统\nAT-WTC800',
                    // 'desc':"首创整盘装管，\n装管添管只需5秒",
                    'coverImg':'/imgs/product/third/cxxt/800_product_list_cxxt.png'
                },
                {
                    'id':'thirdCxxt240',
                    'title':'智能采血系统',
                    'name':'智能采血系统\nAT-WTC240',
                    // 'desc':"单机并联流水线，\n岗位独立操作互不影响",
                    'coverImg':'/imgs/product/third/cxxt/240_product_list_cxxt.png'
                },
                {
                    'id':'thirdCxxt240M',
                    'title':'智能采血系统',
                    'name':'智能采血系统\nAT-WTC240-M',
                    // 'desc':"适用于医院病房内使用",
                    'coverImg':'/imgs/product/third/cxxt/240M_product_list_cxxt.png'
                },
                {
                    'id':'thirdCxxt300',
                    'title':'智能采血系统',
                    'name':'智能采血系统\nAT-WTC300',
                    // 'desc':"适用于：县（区）级医院",
                    'coverImg':'/imgs/product/third/cxxt/300_product_list_cxxt.png'
                },
                {
                    'id':'thirdZtxcjxt',
                    'title':'自体血采集系统',
                    'name':'自体血采集系统',
                    // 'desc':"适用于医院输血科自体血\n采集",
                    'coverImg':'/imgs/product/third/ztxcjxt/product_list_ztxcjxt.png'
                },
                {
                    'id':'thirdBbzyjqr',
                    'title':'智能标本转运机器人',
                    'name':'智能标本转运机器人',
                    // 'desc':"适用于门诊、急诊、病房、\n体检中心、社康中心",
                    'coverImg':'/imgs/product/third/bbzyjqr/product_list_bbzyjqr.png'
                },
                {
                    'id':'thirdBbfj',
                    'title':'智能标本分拣系统',
                    'name':'智能标本分拣系统',
                    // 'desc':"适用于门诊、急诊、病房、\n体检中心、社康中心",
                    'coverImg':'/imgs/product/third/bbfj/product_list_bbfj.png'
                },
                {
                    'id':'thirdNggl',
                    'title':'智能尿管管理系统',
                    'name':'智能尿管管理系统',
                    // 'desc':"适用于门诊、急诊、病房、\n体检中心、社康中心",
                    'coverImg':'/imgs/product/third/nggl/product_list_nggl.png'
                },
                // {
                //     'id':'thirdDgncxzjhszz',
                //     'title':'多功能采血桌及回收装置',
                //     'name':'多功能采血桌及回收装置',
                //     'desc':"匀速，可视，对标本无任何损害",
                //     'coverImg':'/imgs/product/third/dgncxzjhszz/product_list_dgncxzjhszz.png'
                // },
            ],

        };
    },
    computed: {
        navTotalSteps() {
            return Math.ceil((this.nav.length - this.navProductsToShow) / this.navProductsToShow);
        },
        navDisplayedProducts() {
            const start = this.navCurrentIndex * this.navProductsToShow;
            return this.nav.slice(start, start + this.navProductsToShow);
        },
        navLeftButtonClass() {
            return {
                'disabled-btn': this.navCurrentIndex <= 0
            };
        },
        navRightButtonClass() {
            return {
                'disabled-btn': this.navCurrentIndex >= this.navTotalSteps
            };
        },
        nav2TotalSteps() {
            return Math.ceil((this.nav2.length - this.nav2ProductsToShow) / this.nav2ProductsToShow);
        },
        nav2DisplayedProducts() {
            const start = this.nav2CurrentIndex * this.nav2ProductsToShow;
            return this.nav2.slice(start, start + this.nav2ProductsToShow);
        },
        nav2LeftButtonClass() {
            return {
                'disabled-btn': this.nav2CurrentIndex <= 0
            };
        },
        nav2RightButtonClass() {
            return {
                'disabled-btn': this.nav2CurrentIndex >= this.nav2TotalSteps
            };
        }
    },
    methods: {
        selectType(typeId) {
            this.productType = typeId;
            // 更新路由参数，而不重新加载页面
            this.$router.push({ path: '/product', query: { productType: typeId } });
            
        },
        //滚动事件
        handleScroll() {
            var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
            this.pos = scrollTop==0?true:false
        },
        handleNav(e){
            document.getElementById(e.id).scrollIntoView({behavior: "smooth",block: "start",})
            // if (e.typeId == "cplx1") {
            //     document.getElementById(1).scrollIntoView({behavior: "smooth",block: "start",})
            // } else if(e.typeId == "cplx2"){
            //     document.getElementById(2).scrollIntoView({behavior: "smooth",block: "start",})
            // }
            // this.$router.push('/'+e.id+'?nav=Product&productType='+this.productType)
            // location.href = "#"+e.id
        },
        handleDetail(e){
            // 使用$router.push回到指定页面，并传递参数
            const scrollPosition = window.scrollY;
            // this.$router.push({
            //     path: "/" + e.id,
            //     query: {
            //         nav: Product,
            //         productType: this.productType,
            //         // scrollPosition: scrollPosition,
            //     },
            // });
            this.$router.push('/'+e.id+'?nav=Product&productType='+this.productType + '&scrollPosition=' + scrollPosition)
            // this.$router.push('/'+e.id+'?nav=Product')
        },
    },
    created() {
        document.title = "深圳市傲天医疗智能系统有限公司-产品系列"
        document.body.scrollTop = 0
        document.documentElement.scrollTop = 0
        EventBus.$on('productType', (num) => {
            his.productType = num
        })
    },
    mounted() {
        
        // 检查URL参数
        const params = new URLSearchParams(window.location.search);
        const productTypeValue = params.get('productType');
        const scrollPositionValue = params.get('scrollPosition');
        // 如果有参数，则更改显示
        if (productTypeValue) {
            this.productType = productTypeValue;
        };
        this.$nextTick(() => {
            if (scrollPositionValue) {
                window.scrollTo(0, scrollPositionValue);
            }
        });
        new Swiper(".first-swiper", {
            // 如果需要分页器
            pagination: ".first-swiper .swiper-pagination",
            paginationClickable:true,
            nextButton: '.first-swiper .swiper-button-next',
            prevButton: '.first-swiper .swiper-button-prev',
        });
        new Swiper(".second-swiper", {
            // 如果需要分页器
            pagination: ".second-swiper .swiper-pagination",
            paginationClickable:true,
            nextButton: '.second-swiper .swiper-button-next',
            prevButton: '.second-swiper .swiper-button-prev',
        });
        window.scrollTo(0,0);
        window.addEventListener('scroll', this.handleScroll, true);
    },
    beforeDestroyed(){
        window.removeEventListener('scroll', this.handleScroll)
    },
};
</script>
<style lang="less" scoped>

.product-gallery {
    display: flex;
    align-items: center;
    overflow: hidden;
}

.arrow-btn {
    margin: 10px;
    width: 2.77rem;
    height: 2.77rem;
    border:2px solid #999999;
    box-sizing: border-box;
    border-radius: 50%;
    background-image: none !important;
    text-align: center;
    line-height: 2.66rem;
    font-size: 1.33rem;
    color: #999999;
    font-weight: bold;
    position: relative;
    z-index: 3;
    cursor: pointer;
}

.disabled-btn {
    opacity: 0.5;
    cursor: not-allowed;
}

#selector-product-type {
    cursor: pointer;
    overflow: hidden;
    margin-left: 13rem;
    justify-content: center;
    width:100%;
}

.product-type-bottom{
    border-bottom: 4px solid #F3F3F3;
    position: fixed;
    margin-left: 2rem;
    padding-right: 1.5rem;
    justify-content: center;
    cursor: pointer;
    top: 7.1rem;
    width: 94vw;
}

#product-type {
    margin: 0rem 1rem;
    font-size: 1rem;
    display: flex;
    justify-content: center;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    padding-bottom: 1.3rem;
    border: none;
    width: 5.6rem;
}

#selector-product-type div.active::after {
  content: '';
  position: absolute;
  bottom: 0.91rem;
  width: 100%;
  height: 3px;
  background: #0F45F9;
}
  
/* 为特定的子级div重置悬停时的线条样式 */  
#selector-product-type #product-type:hover {  
  border: none !important; /* 移除线条，使用!important来确保覆盖 */  
}

.h3-title::after {
  content: '';
  display: block;
  left: 0;
  bottom: 0;
  width: 100%; /* 设置宽度为100%，跟随文本变化 */
  height: 0.4rem; /* 下划线高度 */
  background-color: #0f45f9; /* 下划线颜色 */
}

.product {
    background: #F9F9F9;
    padding-bottom: 7.7rem;
    .banner {
        width: 100vw;
        position: relative;
        min-height: 25.8rem;
        top: 2.7rem;
        img {
            width: calc(100vw + 25px);
            min-height: 25.8rem;
            position: relative;
            z-index: 1;
            object-fit: cover;
        }
        > div {
            width: 100vw;
            height: 100%;
            position: absolute;
            left: 0;
            top: 0;
            z-index: 2;
            display: flex;
            flex-direction: column;
            align-items: flex-end;
            color: #fff;
            > h1 {
                font-size: 2.5rem;
                margin-top: 13vh;
                margin-right: 10vw;
                margin-bottom: 1.5vh;
            }
            > p {
                max-width: 80vw;
                text-align: right;
                font-size: 1.1rem;
                line-height: 1.6rem;
                margin: 0;
                margin-right:10vw;
            }
        }
    }
    .title {
        display: flex;
        flex-direction: column;
        align-items: center;
        > h3 {
            margin: 0;
            font-size: 2.6rem;
        }
        // > span {
        //     display: block;
        //     width: 13rem;
        //     height: 0.4rem;
        //     background: #0f45f9;
        //     margin-bottom: 1rem;
        // }
        > p {
            font-size: 1.33rem;
        }
    }
    .pro1 {
        max-width: 100vw;
        .pro-title {
            margin-bottom: -3.3rem;
            margin-top: 4rem;
        }
        .pro-swiper-container{
            width: calc(100vw - 40px);
            overflow: hidden;
            position: relative;
            margin: 20px auto -85px auto;
            .swiper-slide{
                width: 100vw;
                display: flex;
            }
        }
        .pro-content-item {
            max-width: 100vw;
            width: 67rem;
            margin: 2rem auto;
            background: #ffffff;
            box-shadow: 0px 0px 20px 0px rgba(15, 24, 55, 0.1);
            border-radius: 20px;
            margin-bottom: 20px;
            display: flex;
            flex-wrap: wrap;
            overflow: hidden;
            .pro-content-item-cover {
                width: 40rem;
                height: 34.4rem;
                max-width: 100vw;
                position: relative;
                overflow: hidden;
                display: flex;
                align-items: center;
                justify-content: center;
                img {
                    height: 100%;
                    object-fit: contain;
                }
            }
            .pro-content-item-desc {
                color: #000;
                width: 27rem;
                display: flex;
                flex-direction: column;
                >h2{
                    font-size: 1.66rem;
                    margin:5rem 2rem 2rem;
                    white-space: pre-wrap;
                }
                > h3 {
                    white-space: pre-wrap;
                    margin:0 2rem;
                    font-size: 1.66rem;
                    line-height: 3rem;
                }
                > p{
                    white-space: pre-wrap;
                    margin:0 2rem;
                    font-size: 1.3rem;
                    line-height: 3rem;
                }
                > div {
                    margin:6rem 2rem;
                    width: 8rem;
                    height: 2.7rem;
                    background: #0f45f9;
                    color: #fff;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    cursor: pointer;
                    opacity: 1;
                    transition: all 0.3s ease;
                    &:hover{
                        opacity: 0.7;
                    }
                }
            }
        }
    }
    .pro2 {
        max-width: calc(100vw - 40px);
        width: 67rem;
        margin: 0 auto;
        position: relative;
        .pro-title {
            margin-bottom: 1.5rem;
        }
        .pro-content-item {
            width: 100%;
            background: #ffffff;
            box-shadow: 0px 0px 20px 0px rgba(15, 24, 55, 0.1);
            border-radius: 20px;
            display: flex;
            flex-wrap: wrap;
            overflow: hidden;
            .pro-content-item-cover {
                width: 40rem;
                height: 34rem;
                max-width: 100vw;
                position: relative;
                overflow: hidden;
                display: flex;
                align-items: center;
                justify-content: center;
                img {
                    height: 100%;
                    object-fit: contain;
                }
            }
            .pro-content-item-desc {
                color: #000;
                width: 27rem;
                display: flex;
                flex-direction: column;
                justify-content: center;
                >h2{
                    font-size: 1.66rem;
                    margin-left: 4rem;
                    margin-bottom: -1rem;
                    white-space: pre-wrap;
                }
                > h3 {
                    white-space: pre-line;
                    font-size: 1.66rem;
                    line-height: 3rem;
                    margin-left: 4rem;
                    margin-bottom: 2rem;
                }
                > p{
                    white-space: pre-wrap;
                    margin:0 4rem;
                    font-size: 1.3rem;
                    // line-height: 3rem;
                    margin-bottom: 4rem;
                }
                > div {
                    margin:0 4rem 2rem;
                    width: 8rem;
                    height: 2.7rem;
                    background: #0f45f9;
                    color: #fff;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    cursor: pointer;
                    opacity: 1;
                    transition: all 0.3s ease;
                    &:hover{
                        opacity: 0.7;
                    }
                }
            }
        }
    }
    .space{
        min-height: 5rem;
        height: 12rem;
        width: 100%;
        z-index: -1;
    }
    .nav-pc{
        position: fixed;
        z-index: 999;
        left: 0;
        top: 5.4rem;
        width: 100vw;
        background: #fff;
        >div{
            display: flex;
            justify-content: space-around;
            font-size: 0.77rem;
            width: 100vw;
            >div{
                cursor: pointer;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                box-sizing: border-box;
                border-bottom:3px solid #fff;
                white-space: nowrap;
                .img{
                    height: 3.88rem;
                    overflow: hidden;
                    transition: all 0.3s ease;
                }
                &:hover{
                    border-bottom:3px solid #0F45F9;
                    color: #0F45F9;
                }
            }
        }
    }
    .nav-xs{
        z-index: 999;
        position: fixed;
        left: 0;
        top: 5.6rem;
        width: 100vw;
        background: #fff;
        overflow-x:auto;
        >div{
            display: flex;
            justify-content: space-between;
            font-size: 0.77rem;
            width: 100vw;
            >div{
                cursor: pointer;
                min-width: 8rem;
                margin: 0 2rem;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                box-sizing: border-box;
                border-bottom:3px solid #fff;
                white-space: nowrap;
                .img{
                    height: 3.88rem;
                    object-fit: contain;
                    transition: all 0.3s ease;
                    overflow: hidden;
                    img{
                        height: 2.88rem;
                    }
                }
                &:hover{
                    border-bottom:3px solid #0F45F9;
                }
            }
        }
    }
}
</style>
